module.exports = __webpack_public_path__ + "static/mockup_banner-pc-a33dc345b33b4e6f24ac67c99ecdb284.png";